import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { CheckCircle2, AlertCircle, ArrowLeft } from "lucide-react";

export default function UnsubscribePage() {
    const [params] = useSearchParams();
    const token = params.get("token");
    const [status, setStatus] = useState({ loading: true, ok: false, msg: "" });

    useEffect(() => {
        if (!token) {
            setStatus({ loading: false, ok: false, msg: "This unsubscribe link is missing its token." });
            return;
        }
        api.get("/unsubscribe/one-click", { params: { token } })
            .then((r) => {
                if (r.data.success) setStatus({ loading: false, ok: true, msg: r.data.message });
                else setStatus({ loading: false, ok: false, msg: "We could not process this request." });
            })
            .catch((err) => setStatus({ loading: false, ok: false, msg: formatApiError(err.response?.data?.detail) }));
    }, [token]);

    return (
        <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="unsubscribe-page">
            {status.loading ? (
                <p className="inline-flex items-center gap-2 font-mono text-sm text-dim">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent animate-pulse-dot" />
                    Processing your request…
                </p>
            ) : status.ok ? (
                <div className="panel p-10 border-pos/30" data-testid="unsubscribe-page-success">
                    <span className="grid place-items-center w-16 h-16 mx-auto rounded-full bg-pos/10 text-pos">
                        <CheckCircle2 size={30} />
                    </span>
                    <h1 className="font-display text-2xl font-black uppercase tracking-[-0.025em] mt-5">You're unsubscribed</h1>
                    <p className="mt-3 text-sm text-dim leading-relaxed">{status.msg}</p>
                </div>
            ) : (
                <div className="panel p-10 border-neg/30" data-testid="unsubscribe-page-error">
                    <span className="grid place-items-center w-16 h-16 mx-auto rounded-full bg-neg/10 text-neg">
                        <AlertCircle size={30} />
                    </span>
                    <h1 className="font-display text-2xl font-black uppercase tracking-[-0.025em] mt-5">Something went wrong</h1>
                    <p className="mt-3 text-sm text-dim leading-relaxed">{status.msg}</p>
                </div>
            )}
            <Link to="/" className="mt-8 inline-flex items-center gap-1.5 font-mono text-xs uppercase tracking-wider text-accent link-underline">
                <ArrowLeft size={13} /> Back home
            </Link>
        </div>
    );
}
